import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import map from "lodash/map";

import useActions from "../../../../hooks/useActions";
import { generateAndDownloadReport } from "../../../../../actions/reportsActions";

import { requestForQuotePDFSpecsDataComponentId, SpecsGrid } from "./SpecsGrid";
import withSelectedRowsAPI from "../../../../ui/BWGrid/withSelectedRowsAPI";
import { ActionButtons } from "../../../../forms";
import propTypes from "../../../../../constants/propTypes";
import { closeModalDialog } from "../../../../../actions/layoutActions";

const ActionButtonsWrapper = styled.div`
  padding-top: 24px;
`;

const GridWrapper = styled.div`
  max-height: calc(75vh - 96px);
  overflow-y: auto;
`;

const DownloadRequestForQuotePDF = ({
  bidGroupVendorId,
  specIds,
  selectedRows,
}) => {
  const actions = useActions({
    generateAndDownloadReport,
    closeModalDialog,
  });

  const handleGeneratePDF = useCallback(
    (skip = false) => () => {
      actions.generateAndDownloadReport({
        format: "pdf",
        referenceId: bidGroupVendorId,
        bidGroupVendorId,
        templateName: "request-for-quote-details",
        selectedSpecIds: skip ? [] : map(selectedRows, "id"),
      });
      actions.closeModalDialog();
    },
    [actions, bidGroupVendorId, selectedRows]
  );

  return (
    <div>
      <GridWrapper>
        <SpecsGrid specIds={specIds} />
      </GridWrapper>
      <ActionButtonsWrapper>
        <ActionButtons
          onSend={handleGeneratePDF()}
          onSecondary={handleGeneratePDF(true)}
          sendButtonText="Add"
          secondaryButtonText="Skip"
          additionalProps={{
            send: {
              disabled: selectedRows.length === 0,
            },
          }}
          listeners={[requestForQuotePDFSpecsDataComponentId]}
          hideCancelButton
          isModal
        />
      </ActionButtonsWrapper>
    </div>
  );
};
DownloadRequestForQuotePDF.propTypes = {
  bidGroupVendorId: PropTypes.string.isRequired,
  specIds: PropTypes.arrayOf(PropTypes.string),
  selectedRows: PropTypes.arrayOf(propTypes.spec),
};

export default withSelectedRowsAPI(DownloadRequestForQuotePDF);
